<mat-button-toggle-group *ngIf="options">
  <mat-button-toggle
    *ngFor="let item of options"
    [checked]="item.id == selectedOptionId"
    [value]="item?.id"
    (change)="onChange($event)"
    >{{ item?.caption }}</mat-button-toggle
  >
</mat-button-toggle-group>
